/**
 * Matches server `parkingSubmissionWindow.ts`: 48 hours after the game is finished.
 */
export const PARKING_WINDOW_MS = 48 * 60 * 60 * 1000;

export const PARKING_WINDOW_CLOSED_MESSAGE = "Parking can only be submitted within 48 hours after the game is finished.";

export function isParkingSubmissionOpen(anchorMs: number, now = Date.now()): boolean {
  if (!Number.isFinite(anchorMs) || anchorMs <= 0) return false;
  return now <= anchorMs + PARKING_WINDOW_MS;
}
